import apiClient from './authService'

class ReportsService {
    async makeRequest(endpoint, options = {}) {
        const url = `/api/v1/reports/${endpoint}`
        
        try {
            const response = await apiClient({
                url,
                ...options
            })
            
            return response.data
        } catch (error) {
            console.error('Erro na requisição:', error)
            throw error
        }
    }

    // Relatórios personalizados
    async generateCustomReport(reportData) {
        try {
            const response = await apiClient({
                url: '/api/v1/reports/custom-reports/',
                method: 'POST',
                data: reportData
            })

            return response.data
        } catch (error) {
            console.error('Erro ao gerar relatório personalizado:', error)
            throw error
        }
    }

    async previewCustomReportPDF(reportData) {
        try {
            const response = await apiClient({
                url: '/api/v1/reports/custom-reports/preview-pdf/',
                method: 'POST',
                data: reportData,
                responseType: 'blob'
            })

            return response.data
        } catch (error) {
            console.error('Erro ao gerar preview do PDF:', error)
            throw error
        }
    }

    async downloadCustomReportPDF(reportData) {
        try {
            const response = await apiClient({
                url: '/api/v1/reports/custom-reports/download-pdf/',
                method: 'POST',
                data: reportData,
                responseType: 'blob'
            })

            return response.data
        } catch (error) {
            console.error('Erro ao baixar PDF:', error)
            throw error
        }
    }
}

export default new ReportsService() 